package com.zaurh.portfolio.data

import androidx.compose.ui.graphics.Color

data class ProjectGradient(
    val first: Color,
    val second: Color
)

val gradients = listOf(
    ProjectGradient(Color(0xFFF0C27B), Color(0xFF4B1248)),
    ProjectGradient(Color(0xFF870000), Color(0xFF190A05)),
    ProjectGradient(Color(0xFF59CDE9), Color(0xFF0A2A88)),
    ProjectGradient(Color(0xFF00C9FF), Color(0xFF92FE9D)),
    ProjectGradient(Color(0xFFFF9966), Color(0xFFFF5E62)),
    ProjectGradient(Color(0xFF36D1DC), Color(0xFF5B86E5)),
    ProjectGradient(Color(0xFFA18CD1), Color(0xFFFBC2EB)),
    ProjectGradient(Color(0xFF11998E), Color(0xFF38EF7D)),
    ProjectGradient(Color(0xFF003d4d), Color(0xFF00c996)),
    ProjectGradient(Color(0xFF152331), Color(0xFF000000)),
    ProjectGradient(Color(0xFF093028), Color(0xFF237A57)),
    ProjectGradient(Color(0xFF232526), Color(0xFF414345)),
    ProjectGradient(Color(0xFF606c88), Color(0xFF3f4c6b))
)